import React, { FC, ReactNode } from 'react';
import './ProductSelectionHeader.scss';
import classNames from 'classnames';
import MaterialIcon from '../common/MaterialIcon';
import { getProductSelectionCount, hasProductSelection } from './ProductSelectionUtils';
import { useTranslation } from 'react-i18next';
import { useProductSelection } from './useProductSelection';
import { useStickyHeader } from '../header/useStickyHeader';
import { useMatch } from 'react-router-dom';

export const ProductSelectionHeader: FC<{ header: ReactNode; menu: ReactNode }> = ({ menu, header }) => {
    const { t } = useTranslation();
    const { productSelection, cancelSelection } = useProductSelection();
    const shopSearchMatch = useMatch('/search/*');
    const collectionSearchMatch = useMatch('/collection/search/*');
    const collectionMgmtSearchMatch = useMatch('/collectionmgmt/search/*');
    const { isSticky } = useStickyHeader();

    return (
        <div className="product-selection-wrapper">
            <div
                className={classNames('product-selection-slider', {
                    showHeader: !hasProductSelection(productSelection),
                    showSelection: hasProductSelection(productSelection)
                })}
            >
                <div
                    className={classNames('content-header', {
                        'search-page-product-selection-header':
                            !!shopSearchMatch || !!collectionSearchMatch || !!collectionMgmtSearchMatch
                    })}
                >
                    {header}
                </div>
                <div
                    className={classNames('product-selection-container', {
                        sticky: isSticky && hasProductSelection(productSelection)
                    })}
                >
                    <div className="product-selection-menu" data-testid="ProductSelectionMenu">
                        <button className="close" onClick={cancelSelection}>
                            <MaterialIcon icon="clear" />
                        </button>
                        <div className="selected-count">
                            {hasProductSelection(productSelection) ? (
                                <span>
                                    {t('shop.subscriptions.selectionCount', {
                                        selectionCount: getProductSelectionCount(productSelection)
                                    })}
                                </span>
                            ) : null}
                        </div>
                        {menu}
                    </div>
                </div>
            </div>
        </div>
    );
};
